import ContactForm from "@/components/ContactForm";
import FooterSection from "@/components/FooterSection";
import NavBar from "@/components/NavBar";
import RelatedGlossary from "@/components/RelatedGlossary";
import SideSection from "@/components/SideSection";
import Head from "next/head";
import { convert } from "html-to-text";

const sanitizeHtml = (html) => {
  const sanitized = convert(html, {
    wordwrap: 130,
    selectors: [{ selector: "img", format: "skip" }],
  });

  return sanitized.replace(/\s+/g, " ").trim();
};

function Page({ glossaryData, additionalGlossaries, error }) {
  if (error) {
    return (
      <div className="text-white no-grossary-found">No Glossary Found</div>
    );
  }

  return (
    <>
      <Head>
        <title>{glossaryData ? glossaryData.metaTitle : "Loading..."}</title>
        <meta
          name="keywords"
          content={glossaryData ? glossaryData.metaKeyword : "Loading..."}
        />
        <meta
          name="description"
          content={
            glossaryData
              ? sanitizeHtml(glossaryData.metaDescription)
              : "Loading..."
          }
        />
        <meta
          name="author"
          description={
            glossaryData && glossaryData.user
              ? `${glossaryData.user.name} ${glossaryData.user.email}`
              : "Loading..."
          }
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="Headbg">
        <div className="container">
          <NavBar />
          <div className="mt-5">
            <h4 className="textGradient fs-3 fw-bold text-center mb-2">
              {glossaryData && glossaryData.title}
            </h4>
            <p
              className="text-center text-white fs-5 truncate-lines"
              // dangerouslySetInnerHTML={{
              //   __html: glossaryData.description,
              // }}
            >
              {glossaryData && sanitizeHtml(glossaryData.description)}
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-9 col-md-12 col-12">
            <div className="costMargin detailsPage">
              {glossaryData && (
                <>
                  <h2 className="textGradient fs-3 fw-bold mb-4">
                    {glossaryData.title}
                  </h2>
                  {/* <h3 className="text-white fs-5 mb-4">
                    {glossaryData.keyword}
                  </h3> */}
                  <div
                    className="text-white fs-5 mb-4"
                    dangerouslySetInnerHTML={{
                      __html: glossaryData.description,
                    }}
                  />

                  {/* <ul>
                    <li>
                      Author: {glossaryData.user.name} (
                      {glossaryData.user.email})
                    </li>
                  </ul> */}
                  <div className="clearfix"></div>
                </>
              )}
              {additionalGlossaries?.length > 0 && (
                <>
                  <h5 className="textGradient fs-4 fw-bold mt-3">
                    Related Glossaries
                  </h5>
                  <RelatedGlossary
                    additionalGlossaries={additionalGlossaries}
                  />
                </>
              )}
            </div>
          </div>
          <div className="col-xl-3 col-md-12 col-12">
            <SideSection />
          </div>
        </div>
      </div>
      <div className="container">
        <ContactForm />
      </div>
      <FooterSection />
    </>
  );
}

export async function getServerSideProps(context) {
  const { slug } = context.query;
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3002"
      : process.env.NEXT_PUBLIC_API_BASE_URL;
  try {
    const response = await fetch(`${baseUrl}/api/glossary?title=${slug}`);
    if (!response.ok) {
      return { props: { error: true } };
    }
    const data = await response.json();
    return {
      props: {
        glossaryData: data.glossary,
        additionalGlossaries: data.additionalGlossaries,
        error: false,
      },
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { props: { error: true } };
  }
}

export default Page;
